import MypagePayContainer from './MypagePayContainer';
export default MypagePayContainer;
